// ADd config
import axios from "axios";

const apiRequestGlobal = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    timeout: 10000,
  },
});

export const apiRequestForm = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    timeout: 10000,
  },
});

let isRedirecting = false;

const handleLogout = () => {
  localStorage.removeItem("authToken");
  removeApiServiceHeader({ key: "Authorization" });

  // Only redirect if not already on auth page
  if (!isRedirecting && !window.location.pathname.includes("/login")) {
    isRedirecting = true;
    window.location.href = "/login";
  }
};

apiRequestGlobal.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

const authToken = localStorage.getItem("token");
if (authToken) {
  apiRequestGlobal.defaults.headers.common["Authorization"] =
    `Bearer ${authToken}`;
  apiRequestForm.defaults.headers.common["Authorization"] =
    `Bearer ${authToken}`;
}

export function removeApiServiceHeader({ key }: { key: string }) {
  apiRequestGlobal.defaults.headers.common[key] = "";
  apiRequestForm.defaults.headers.common[key] = "";
}

export function setApiServiceHeader({
  key,
  value,
}: {
  key: string;
  value: string;
}) {
  apiRequestGlobal.defaults.headers.common[key] = `Bearer ${value}`;
  localStorage.setItem(key, value);
  apiRequestForm.defaults.headers.common[key] = `Bearer ${value}`;
  localStorage.setItem(key, value);
}

export default apiRequestGlobal;
